var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex-between" },
        [
          _c("div", { staticClass: "title-16" }, [_vm._v("字段列表")]),
          _vm._v(" "),
          _c(
            "el-popover",
            { attrs: { placement: "bottom", width: "230", trigger: "click" } },
            [
              _c("el-input", {
                staticClass: "input",
                staticStyle: { width: "100%" },
                attrs: {
                  "prefix-icon": "el-icon-search",
                  size: "small",
                  placeholder: "请输入关键字",
                  clearable: "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _vm._v(" "),
              _c(
                "el-scrollbar",
                {
                  staticStyle: { height: "500px" },
                  attrs: { "wrap-class": "scrollbar-wrapper" },
                },
                _vm._l(_vm.searchList, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "line" },
                    _vm._l(item.options, function (i, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "field-text",
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(i)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(i.label) +
                              " / " +
                              _vm._s(i.value) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { slot: "reference", size: "small", type: "primary" },
                  slot: "reference",
                },
                [
                  _vm._v("新建字段"),
                  _c("i", { staticClass: "el-icon-arrow-down" }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "flex mb10 h32" }, [
        _c("div", { staticClass: "inTotal" }, [
          _vm._v("共 " + _vm._s(_vm.tableData.length) + " 项"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml14" },
          [
            _c("el-input", {
              staticClass: "input",
              staticStyle: { width: "250px" },
              attrs: {
                "prefix-icon": "el-icon-search",
                size: "small",
                placeholder: "请输入关键字",
                clearable: "",
              },
              on: { change: _vm.getList },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.getList($event)
                },
              },
              model: {
                value: _vm.where.name,
                callback: function ($$v) {
                  _vm.$set(_vm.where, "name", $$v)
                },
                expression: "where.name",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "table-box",
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { "row-key": "id", data: _vm.tableData },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "field_name_en",
                  label: "字段名称",
                  "min-width": 150,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "mr10" }, [
                          _vm._v(" " + _vm._s(scope.row.field_name_en)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "主键字段",
                              placement: "top-start",
                            },
                          },
                          [
                            scope.row.field_name_en == "id"
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "ml4",
                                    attrs: { size: "mini" },
                                  },
                                  [_vm._v("主")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "系统字段",
                              placement: "top-start",
                            },
                          },
                          [
                            scope.row.is_default == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "ml4",
                                    attrs: { size: "mini", type: "warning" },
                                  },
                                  [_vm._v("系")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "主从字段",
                              placement: "top-start",
                            },
                          },
                          [
                            scope.row.is_re_table > 0
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "ml4",
                                    attrs: { size: "mini", type: "info" },
                                  },
                                  [_vm._v("从")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "field_name", label: "显示名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "form_value", label: "字段类型" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_default_value_not_null", label: "是否必填" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.is_default_value_not_null > 0
                                ? "--"
                                : "是"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "data_dict_name", label: "关联字典" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.data_dict_name || "--") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "association_crud_table_name",
                  label: "引用实体",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getValue(
                                scope.row.association_crud_table_name
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_main", label: "主字段展示" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            width: 60,
                            disabled:
                              scope.row.form_value !== "input" ||
                              scope.row.is_main == 1,
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "开启",
                            "inactive-text": "关闭",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleMain(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.is_main,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "is_main", $$v)
                            },
                            expression: "scope.row.is_main",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "address",
                  label: "操作",
                  fixed: "right",
                  width: "170",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.is_default !== 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editFn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.is_default !== 1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFn(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          fromData: _vm.fromData,
          formConfig: _vm.formConfig,
          formRules: _vm.formRules,
          formDataInit: _vm.formDataInit,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }